import { Logger } from '../logger';
import { request } from '../request';
import { AdRequestManager } from './ad-request';
import { AdUtils } from './ad-utils';

export interface ISaveGameInfo {
  // 微信小游戏AppID
  appid: string;
  // 游戏标题
  title: string;
  // 游戏副标题
  sub_title: string;
  // 游戏图标URL
  icon_url: string;
  // 游戏打开链接
  open_url: string;
  // 游戏路径
  path?: string;
  // 游戏二维码URL
  qr_code_url?: string;
  // 按钮文案
  btnText?: string;
}

export interface ISaveGameRequest {
  wx_appid: string;
  // 游戏信息
  transfer: string;
}

const logger = new Logger({
  name: 'ad-save-mini-game',
});

const SAVE_GAME_URL = 'https://pbaccess.video.qq.com/trpc.business_feeds.dsp_feeds_pc.RecentPlayWrite/SaveGame';
const SAVE_GAME_URL_TEST = 'https://tpbaccess.video.qq.com/trpc.business_feeds.dsp_feeds_pc.RecentPlayWrite/SaveGame';

const requestSaveGameInfo = async (gameInfo: ISaveGameInfo) => {
  const vuid = AdUtils.getVuid();

  if (!vuid) {
    return;
  }

  const headers = AdRequestManager.getAdHeaders();

  const res = await request.post<ISaveGameRequest>(
    `${AdUtils.isDebugEnv() ? SAVE_GAME_URL_TEST : SAVE_GAME_URL}?video_appid=${headers.video_appid}`,
    {
      wx_appid: gameInfo.appid,
      transfer: JSON.stringify(gameInfo),
    },
    { withCredentials: true, headers },
  );

  logger.log(`保存小游戏：${JSON.stringify(res)}`);
};

// 小游戏玩过列表数据结构
export interface IMiniProgramSaveData {
  appid: string;
  path: string;
  /**
   * 广告 logo 图片
   */
  logo: string;
  /**
   * 小游戏标题
   */
  title: string;
  subTitle: string;
  /**
   * 二维码链接
   */
  qrcodeUrl?: string;
  wxGameLink: string;
  btnText?: string;
}

const saveToStorage = (gameInfo: ISaveGameInfo) => {
  const vuid = AdUtils.getVuid() || '0';
  const guid = AdUtils.getGUID() || '';

  const miniGame: IMiniProgramSaveData = {
    appid: gameInfo.appid,
    path: gameInfo.path,
    logo: gameInfo.icon_url,
    title: gameInfo.title,
    subTitle: gameInfo.sub_title,
    qrcodeUrl: gameInfo.qr_code_url,
    btnText: gameInfo.btnText,
    wxGameLink: gameInfo.open_url,
  };

  const saveKey = `${vuid}-${guid}`;

  function saveMiniGameData(value?: string) {
    const gameList: IMiniProgramSaveData[] = [
      miniGame,
    ];

    try {
      const temp = JSON.parse(value);
      if (Array.isArray(temp)) {
        temp.forEach((v: IMiniProgramSaveData) => {
          if (v.appid !== miniGame.appid) {
            gameList.push(v);
          }
        });
      }
    } catch (e) {
      console.error('[ad]saveMiniGameData-error', e);
    }

    vn.storage.setStorage({
      key: saveKey,
      data: gameList,
      success: null,
      fail: null,
      complete: null,
      expires: Number.MAX_SAFE_INTEGER,
    });
  }

  vn.storage.getStorage({
    key: saveKey,
    success: (value) => {
      saveMiniGameData(value);
    },
    fail: () => {
      saveMiniGameData();
    },
    complete: null,
  });
};

export const saveMiniGameInfo = async (gameInfo: ISaveGameInfo) => {
  try {
    saveToStorage(gameInfo);
  } catch (e) {
    logger.log(`保存小游戏到本地错误：${e}`);
  }

  try {
    await requestSaveGameInfo(gameInfo);
  } catch (e) {
    logger.log(`保存小游戏到后台错误：${e}`);
  }
};
